import React from "react";
import theme from "../../theme.scss";
import { IconProps } from "./types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";

export const CircleCheckIcon = ({ width, colour }: IconProps) => {
  return (
    <FontAwesomeIcon
      icon={faCircleCheck}
      color={colour ?? theme.neutral7}
      fontSize={width ?? "16px"}
    />
  );
};
